import * as process from "process";
import { MultiAppConfig } from "./MultiAppConfig";

const REACT_BASE_API_URL = process.env.REACT_BASE_API_URL;
const REACT_APP_MQTT_URL = process.env.REACT_APP_MQTT_URL;

const role = MultiAppConfig.ROLE.toLowerCase();

export const Endpoints = {
  app: {
    config: `/v1/${role}/appConfig`,
    error: `/v1/${role}/appErrors`,
  },
  auth: {
    register: `/v1/${role}/auth/register`,
    companies: `/v1/${role}/companies`,
    request_verify: `/v1/${role}/auth/login-first-step`,
    request_verify_by_email: `/v1/${role}/auth/login-first-step-email`,
    verify: `/v1/${role}/auth/login-second-step`,
    login_courier: `/v1/${role}/auth/login-courier`,
    login_via_invitation: `/v1/${role}/auth/login-invitation`,
  },
  recipient: {
    invitation: (invitationId: string) =>
      `/v1/${role}/invitation/${invitationId}`,
  },
  notification: {
    registerDevice: `/v1/${role}/notifications/devices`,
  },
  profile: {
    me: `/v1/${role}/profile/me`,
    uploadSignature: `/v1/recipient/uploads/signature`,
    setLanguage: `/v1/${role}/profile/language`,
  },
  action: {
    check: (id: string) => `/v1/${role}/parcels/group/${id}/action`,
  },
  faqs: {
    list: `/v1/${role}/faqs`,
  },
  upload: {
    profile: "/v1/recipient/uploads/profile",
  },
  attachments: {
    addParcel: `/v1/${role}/parcelAttachments`,
    removeParcel: (id: string) => `/v1/${role}/parcelAttachments/${id}`,
  },
  kanguroPoints: {
    nearby: `/v1/${role}/kanguroPoints/nearby`,
    byCodeAndDelivery: (code: string, deliveryId: string) =>
      `/v1/${role}/kanguroPoints/code/${code}/delivery/${deliveryId}`,
    getById: (id: string) => `/v1/${role}/kanguroPoints/${id}`,
  },
  parcels: {
    history: `/v1/${role}/parcels/history`,
    current: `/v1/${role}/parcels/current`,
    currentDeliveryDrivers: `/v1/${role}/parcels/current/deliveryDrivers`,
    currentRecipients: `/v1/${role}/parcels/current/recipients`,
    future: `/v1/${role}/parcels/future/deliveryDrivers`,
    currentByKanguroPoint: `/v1/${role}/parcels/current/kanguroPoints`,
    get: (id: string) => `/v1/${role}/parcels/${id}`,
    getByCode: (code: string) => `/v1/${role}/parcels/code/${code}`,
    validate: (id: string) => `/v1/${role}/parcels/${id}`,
    requestConfirmDelivery: (id: string) =>
      `/v1/${role}/parcels/counter/${id}/confirm`,
    confirmParcel: (id: string) => `/v1/${role}/parcels/${id}/confirm-parcels`,
    finish: (id: string) => `/v1/${role}/parcels/${id}`,
    cancel: (id: string) => `/v1/${role}/parcels/${id}`,
    cancelValidation: (id: string) =>
      `/v1/${role}/parcels/${id}/cancel-validation`,
    byGroup: (groupId: string) => `/v1/${role}/parcels/group/${groupId}`,
    cancelByGroup: (groupId: string) =>
      `/v1/${role}/parcels/group/${groupId}/cancel-validation`,
    validating: `/v1/${role}/parcels/validating`,
    create: `/v1/${role}/parcels`,
    update: (id: string) => `/v1/${role}/parcels/${id}`,
    recipientInfo: (phone: number) => `/v1/${role}/parcels/recipients/${phone}`,
    createRecipient: `/v1/${role}/parcels/recipients`,
  },
  incidences: {
    otp: "/v1/incidences",
  },
  rating: {
    rate: `/v1/${role}/ratings`,
  },
  languages: {
    getLanguages: `/v1/languages`,
  },
};

export const SERVER_URL = `${REACT_BASE_API_URL}/`;
export const API_URL = `${REACT_BASE_API_URL}/api`;
export const MQTT_URL = `${REACT_APP_MQTT_URL}/mqtt`;
